export default () =>
  /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
